export const FEATURE_DELETE_CASH_TRANSACTIONS = 'cash_transactions_deletion';
export const FEATURE_USE_POS_AS_SOURCE_OF_PAYOUT_SETTLED_CHARGES = 'use_pos_as_source_of_payout_settled_charges';
export const FEATURE_MIXPANEL_LOGS_ENABLED = 'mixpanel_pos_dashboard_log';
export const FEATURE_USE_MENU_CDS_SETTING = 'use_menu_cds_setting';
